import translate from "@deosite/helpers/langLibrary";
import React, { useEffect, useRef } from "react";
import Grid from "@commerce-ui/core2/Grid";
import Box from "@commerce-ui/core2/Box";
import Container from "@commerce-ui/core2/Container";

import PageContainer from "../../containers/UI/PageContainer";

import SectionWithConfigurableHeader from "../../sections/SectionWithConfigurableHeader";
import ProductBox from "../../components/ProductBox";

import RectangleCardWithLabelInsideSection from "../../sections/RectangleCardWithLabelInsideSection";
import SquareCardWithLabelSection from "../../sections/SquareCardWithLabelSection";
import RectangleCardWithLabelBoxInside from "../../components/RectangleCardWithLabelBoxInside";
import CollectionDetails from "../../components/CollectionDetails";
import Image from "@deosite/components-new/Image";
import useAnalyticsAndCommerceTags from "@deosite/api/hooks/common/useAnalytics4AndCommerceTags";

const BrandPage = ({
  allCollectionProducts,
  brandName,
  footerContent,
  pagination,
  filtersBar,
  dataRequiredToHideLoader,
  prismicData,
  backLabel,
  backClickFunction,
  collectionFromFiltersString,
  totalCount = ""
}) => {
  const translations = {
    seeAll: translate("see all"),
    popularCategories: translate("Popular categories"),
    newIn: translate("New in"),
    allNew: translate("all new"),
    bestsellers: translate("Bestsellers"),
    seoDescription: translate("Default seo description"),
    seoTitle: translate("Default seo title"),
    shopByCollection: translate("Shop by Collection"),
    shopByType: translate("Shop by Type")
  };

  const { viewList } = useAnalyticsAndCommerceTags();
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      viewList(allCollectionProducts, collectionFromFiltersString ?? brandName);
    }
  });

  return (
    <PageContainer
      footerContent={footerContent}
      returnLinkLabel={backLabel}
      onReturnLabelClick={backClickFunction}
      metaTagsData={{
        description: translations.seoDescription,
        title: translations.seoTitle
      }}
      dataRequiredToHideLoader={dataRequiredToHideLoader}
    >
      {prismicData.content?.logo?.originalSrc && (
        <Box sx={{ mt: "s10" }}>
          <Container>
            <Grid cols={[1, null, 20, null]}>
              <Box
                sx={{
                  textAlign: "center",
                  gridColumn: ["span 1", null, "8 / span 6", null]
                }}
              >
                <Image
                  sx={{ objectFit: "contain", maxHeight: "200px" }}
                  image={prismicData.content.logo}
                />
              </Box>
            </Grid>
          </Container>
        </Box>
      )}

      {prismicData?.content?.tiles && (
        <SectionWithConfigurableHeader title={translations.shopByCollection}>
          <Container>
            <RectangleCardWithLabelInsideSection
              rectangleCards={prismicData.content.tiles.map(collectionTile => (
                <RectangleCardWithLabelBoxInside
                  link={collectionTile.url}
                  label={collectionTile.title}
                  image={collectionTile.image}
                  promoLabel={collectionTile.promoLabel}
                />
              ))}
            />
          </Container>
        </SectionWithConfigurableHeader>
      )}

      {prismicData?.content?.types && (
        <SectionWithConfigurableHeader title={translations.shopByType}>
          <Container>
            <SquareCardWithLabelSection
              productTypes={prismicData.content.types}
            />
          </Container>
        </SectionWithConfigurableHeader>
      )}

      {prismicData?.content?.description && pagination.props.currentPage === 1 && (
        <SectionWithConfigurableHeader>
          <Container>
            <Box
              sx={{
                borderBottomWidth: ["1px", null, "0px", null],
                borderTopWidth: ["1px", null, "0px", null],
                borderStyle: "solid",
                borderColor: "neutral"
              }}
            >
              <Grid cols={[1, null, 20, null]}>
                <Box
                  sx={{
                    gridColumn: ["span 1", null, "6 / span 10", null]
                  }}
                >
                  <CollectionDetails
                    collection={prismicData.content.description}
                  />
                </Box>
              </Grid>
            </Box>
          </Container>
        </SectionWithConfigurableHeader>
      )}
      <SectionWithConfigurableHeader
        titleAs={"h1"}
        title={
          collectionFromFiltersString
            ? `${collectionFromFiltersString} - ${brandName} (${totalCount})`
            : `${brandName} (${totalCount})`
        }
      >
        <Container>
          <Box sx={{ width: "100%" }}>{filtersBar}</Box>
          <Grid cols={[2, null, 4, null]}>
            {allCollectionProducts.map((product, index) => (
              <ProductBox key={index} product={product} colors={[]} />
            ))}
          </Grid>
          <Box sx={{ marginTop: "s12" }}>{pagination}</Box>
        </Container>
      </SectionWithConfigurableHeader>
    </PageContainer>
  );
};

export default BrandPage;
